"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQueryEmpty = exports.checkEmpty = exports.extractQuery = exports.trimTrailingSlash = void 0;
const lodash_1 = require("lodash");
const trimTrailingSlash = (url) => url.replace(/\/$/, '');
exports.trimTrailingSlash = trimTrailingSlash;
const extractQuery = (url, { trimBaseUrlTrailingSlash } = {}) => {
    const _url = (0, lodash_1.isString)(url) ? url : url.baseUrl;
    const [baseUrl, queryString] = _url.split('?');
    return {
        baseUrl: trimBaseUrlTrailingSlash ? (0, exports.trimTrailingSlash)(baseUrl) : baseUrl,
        queryString: queryString || undefined
    };
};
exports.extractQuery = extractQuery;
const checkEmpty = (value) => ((0, lodash_1.isObject)(value) || (0, lodash_1.isString)(value) ? (0, lodash_1.isEmpty)(value) : (0, lodash_1.isNil)(value));
exports.checkEmpty = checkEmpty;
const isQueryEmpty = (query) => (0, lodash_1.values)(query).every(exports.checkEmpty);
exports.isQueryEmpty = isQueryEmpty;
